import Link from 'next/link'
import { FC, ReactNode } from 'react'
import styles from './Button.module.scss'
// import { IButton } from '@/src/assets/typeScript/interfaces/buttonInterface'

type TButton = {
    children: ReactNode
    className?: string
    buttonUrl?: string
    onClick?: () => void;
    ariaLabel: string
    target?: boolean
}

const Button: FC<TButton> = ({className, onClick, buttonUrl, children, ariaLabel, target}) => {

    const btnStyle = `${styles.btn} ${className}`;

    return (
        <>
            {buttonUrl ? 
                <Link 
                    href={buttonUrl}
                    className={btnStyle}
                    aria-label={ariaLabel}
                    target={target ? `_blank` : undefined}
                    rel={target ? "noopener noreferrer" : undefined}
                >
                    {children}
                </Link>
                :   <button 
                        className={btnStyle}
                        onClick={onClick}
                        aria-label={ariaLabel}
                    >
                        {children}
                </button>
            }
            
        </>)
}

export default Button